import { AxiosInstance } from 'axios'
import { useContext } from 'react'
import { ClientContext } from './ClientContext'

export const useService = <T>(makeService: (instance: AxiosInstance) => T) => {
  const api = useContext(ClientContext)
  const service = makeService(api)
  return service
}
